function get(k) {
  let result = '';
  const name = k + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  let c;
  for (var i = 0; i < ca.length; i++) {
    c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      result = c.substring(name.length, c.length);
    }
  }
  try {
    return JSON.parse(result);
  } catch (e) {
    return null;
  }
}

function set(k, v, exdays = 14) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + d.toUTCString();
  document.cookie = k + '=' + JSON.stringify(v) + ';' + expires + ';path=/';
}

export const storage = {
  get: get,
  set: set,
};



// WEBPACK FOOTER //
// ./src/libs/localStorage.js